import { Layout } from 'react-admin'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { DashboardMenuItem, MenuItemLink, getResources } from 'react-admin'
import { Divider } from '@material-ui/core'
import DefaultIcon from '@material-ui/icons/ViewList'
import LabelIcon from '@material-ui/icons/Label'

const CustomMenu = ({ onMenuClick, logout }) => {
  const open = useSelector((state) => state.admin.ui.sidebarOpen)
  const resources = useSelector(getResources)
  return (
    <div style={{ marginTop: 8 }}>
      <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} />
      <MenuItemLink
        to="/analytics"
        primaryText="Analytics"
        leftIcon={<LabelIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
      <Divider style={{ margin: '16px 0' }} />
      {resources.map((resource) => (
        <MenuItemLink
          key={resource.name}
          to={`/${resource.name}`}
          primaryText={
            (resource.options && resource.options.label) || resource.name
          }
          leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
        />
      ))}
    </div>
  )
}
const CustomLayout = (props) => <Layout {...props} menu={CustomMenu} />

export default CustomLayout
